export default "__VITE_ASSET__D9s4QaGx__"